/**
 * servicio que encapsula la gestión del sessionStorage.
 *
 * @link [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage)
 */

/**
 * Borra todas las entradas registradas en sessionStorage.
 * @param {RegExp} regexp por defecto "*", permite limitar las claves que queremos borrar
 */
export function clearAll(regexp = /.*/) {
  Object.keys(sessionStorage).forEach((key) => {
    if (regexp.test(key)) {
      sessionStorage.removeItem(key);
    }
  });
}

/**
 * Permite borrar el valor correspondiente a "key" del sessionStorage
 * @param {string} key
 */
export function remove(key) {
  sessionStorage.removeItem(key);
}

/**
 * Devuelve el valor correspondiente a "key"
 * @param {string} key
 * @returns {any}
 */
export function get(key) {
  let res;

  try {
    const value = sessionStorage.getItem(key);
    res = JSON.parse(value);
  } catch (e) {
    console.error(e);
  }

  return res;
}

/**
 * Permite guardar un valor en el sessionStorage.
 * @param {string} key nombre del valor
 * @param {any} value valor que se va guardar
 */
export function set(key, value) {
  try {
    const str = JSON.stringify(value);
    sessionStorage.setItem(key, str);
  } catch (e) {
    console.error(e);
  }
}
